import { gsap } from 'gsap';
import '../util/easings';

export const animation = (() => {
  let logo, logoH, logoE, subheading, scrollPrompt, bgImage, nav;
  const tl = gsap.timeline();

  const init = () => {
    getReferenceElements();
    setTransparentHeader();
    setUpTimeline();
    play(0);
  }

  const play = () => tl.play(0);
  const pause = () => tl.pause();

  const getReferenceElements = () => {
    logo = document.querySelector('.js-home-logo');
    logoH = logo.querySelectorAll('[data-word="harrison"]');
    logoE = logo.querySelectorAll('[data-word="eidsgaard"]');
    subheading = document.querySelector('.js-home-subheading');
    scrollPrompt = document.querySelector('.js-scroll-prompt');
    bgImage = document.querySelector('.js-home-bg-image');
    nav = document.querySelector('.js-navigation');
  }

  const setTransparentHeader = () => {
    gsap.set(nav, { backgroundColor: 'transparent', overwrite: true });
  }

  const setUpTimeline = () => {
    tl
      .fromTo(logoH,
        { y: 80 },
        {
          y: 0,
          duration: 1.417,
          ease: 'kota.easeInOut.1',
        }, 0.33)

      .fromTo(logoE,
        { y: -87 },
        {
          y: 0,
          duration: 1.417,
          ease: 'kota.easeInOut.1',
        }, 0.33)

      .to(bgImage, {
        autoAlpha: 1,
        duration: 0.933,
        ease: 'kota.easeIn.2',
      }, 0.87)

      .to(bgImage, {
        scale: 1.15,
        duration: 13.733,
        ease: 'none',
      }, 1.25)

      .fromTo(scrollPrompt,
        { y: 20 },
        {
          y: 0,
          duration: 0.683,
          ease: 'kota.easeOut.1',
        }, 1.37)

      .to(scrollPrompt, {
        autoAlpha: 1,
        duration: 0.683,
        ease: 'kota.easeIn.1',
      }, 1.37)

      .to(subheading,
        {
          autoAlpha: 1,
          duration: 1.05,
          ease: 'kota.easeIn.1',
        }, 1.72)

      .fromTo(subheading,
        { y: -20 },
        {
          y: 0,
          duration: 1.05,
          ease: 'kota.easeOut.2',
        }, 1.72)

      .to(nav, {
        autoAlpha: 1,
        ease: 'kota.easeIn.1',
        duration: 0.66666666666667,
        overwrite: true,
      }, 1.3)

  }

  return { init, play, pause };
})();
